import {connect} from "react-redux";
import SalesOrderReturn from "./SalesOrderReturn";
import {bindActionCreators} from "redux";
import {fetchSalesReturnMrfDetails, fetchSalesReturnMrfShipments, sendSalesReturnDataToErp} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    getSalesReturnMrfDetails: state.MaterialRequistionForm.getSalesReturnMrfDetails,
    getSalesReturnShipments: state.MaterialRequistionForm.getSalesReturnShipments,
    saveSalesReturnOnErp: state.MaterialRequistionForm.saveSalesReturnOnErp
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchSalesReturnMrfDetails,
            fetchSalesReturnMrfShipments,
            sendSalesReturnDataToErp
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderReturn);
